import { LocationOffOutlined } from '@mui/icons-material';
import { Box, Grid, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CompanySelect } from '@pinnacleautomotive/clarity-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setUserCurrentCompanyId } from '../../redux/actions/userManagementActions';
import { api } from '../../redux/rtk/api';
import {
  currentUserCompanyId,
  selectUserCompaniesWithContracts,
  selectUserCurrentCompanyStatus,
} from '../../redux/selectors/userDataSelectors';
import AppBreadCrumbs from './AppBreadCrumbs';

const PREFIX = 'AppBarResposiveBox';

const classes = {
  container: `${PREFIX}-container`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.container}`]: {
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(1, 3),
    color: theme.palette.info.dark,
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 2),
    },
  },
}));

const AppBarResposiveBox = () => {
  const { t } = useTranslation('global');
  const dispatch = useDispatch();
  const location = useLocation();
  const companies = useSelector(selectUserCompaniesWithContracts);
  const userCompany = useSelector(currentUserCompanyId);
  const userCompanyStatus = useSelector(selectUserCurrentCompanyStatus);

  const handleOnChange = companyId => {
    dispatch(setUserCurrentCompanyId(companyId));
    dispatch(api.util.invalidateTags('CurrentCompany'));
  };

  return (
    <StyledBox>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.container}
      >
        <Grid item>
          <AppBreadCrumbs />
        </Grid>
        <Grid item>
          <Box display="flex" alignItems="center" gap={1}>
            {['/orders', '/workQueue'].includes(location?.pathname) &&
              !userCompanyStatus && (
                <Tooltip title="Deactivated Location">
                  <LocationOffOutlined color="error" fontSize="small" />
                </Tooltip>
              )}
            <CompanySelect
              companies={companies}
              userCompany={userCompany}
              locationDisplay={
                location?.pathname === '/orders' ||
                location?.pathname === '/workQueue'
              }
              placeholder={t('search')}
              onChange={handleOnChange}
            />
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
};

export default AppBarResposiveBox;
